import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { filter, take, switchMap, catchError } from 'rxjs/operators';
import { LoginService } from './login.service'; // Reemplaza con tu servicio de autenticación
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private loginService: LoginService, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.loginService.getAuthToken(); // Método para obtener el token del almacenamiento

    if (authToken) {
      request = this.addToken(request, authToken);
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !request.url.includes('/refresh-token') && !request.url.includes('/auth/login')) {
          // Token de acceso expirado (no es la petición de refresh)
          return this.handle401Error(request, next);
        }

        return throwError(error);
      })
    );
  }

  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.refreshTokenSubject.next(this.loginService.getAuthToken());
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.loginService.refreshToken().pipe( // Llama a tu servicio para refrescar el token
        switchMap((newToken: any) => {
          this.isRefreshing = false;
          this.loginService.setAuthToken(newToken.accessToken);
          localStorage.setItem('REFRESH_TOKEN', newToken.tokenRefresh);
          this.refreshTokenSubject.next(newToken.accessToken);
          return next.handle(this.addToken(this.updateRequest(request), newToken.accessToken));
        }),
        catchError((err) => {
          this.isRefreshing = false;
          this.loginService.logout(); // Cierra la sesión si el refresh token también falla
          this.router.navigate(['/user-pages/login']);
          return throwError(() => err);
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token !== null),
        take(1),
        switchMap(jwt => {
          return next.handle(this.addToken(this.updateRequest(request), jwt));
        })
      );
    }
  }

  private updateRequest(req: HttpRequest<any>) {
    return req.clone({
      headers: req.headers.delete('Authorization')
    });
  }
}
